import {defineStore} from 'pinia'

const name = 'auth'

const userStore = JSON.parse(localStorage.getItem("user.store"));

const initialState = userStore ? {  loggedIn: true , user : userStore } :  {  loggedIn: false , user: null }

export const useAuthStore = defineStore(name,{

  id: name,

  state: () => (initialState),

  actions: {
    updateProfilImage(data){
      this.user.profil_image = data.profil_image
      this.user.cover_image = data.cover_image
      localStorage.setItem("user.store", JSON.stringify(this.user));
    },
    async login(user) {
      localStorage.setItem("user.store", JSON.stringify(user));
      this.loggedIn = true
      this.user = user
    },
    logout() {
      this.loggedIn = false
      this.user = undefined
      localStorage.setItem("user.store", null);
    },
    register(user) {
      this.loggedIn = true;
      this.user = user;
    },
    /**
     * Met à jour UNIQUEMENT les autorités de l'utilisateur courant (fusion),
     * en préservant le reste de l'objet — notamment l'access_token utilisé par
     * authHeader. Appelé par AuthService.refreshCurrentUser après un changement
     * de profil (ex. candidat → recruteur) pour rafraîchir les habilitations
     * sans re-login.
     */
    setAuthorities(authorities) {
      if (!this.user) return;
      this.user.authorities = Array.isArray(authorities) ? authorities : [];
      localStorage.setItem("user.store", JSON.stringify(this.user));
    }

  },
  getters: {
    isLoggedIn:  (state) =>  {
      return state.loggedIn;
    },
    currentUser:  (state) =>  {
      if (state.loggedIn) {
        return state.user;
      } else {
        return null;
      }
    },
    hasPermission:  (state) => (key, module) => {
      if (state.loggedIn) {
        const authorities = state.user.authorities
        // Action générique (APP_GLOBAL_EXPORT) : droit du module courant (« RMS:EXPORT »)
        if (module && String(key).startsWith('APP_GLOBAL_') && authorities.includes(module.toUpperCase() + ':' + key.slice(11))) return true
        // Droit global (APP_GLOBAL_CHAT_BOT) : « APP_GLOBAL:CHAT_BOT », valable sur tous les écrans
        if (String(key).startsWith('APP_GLOBAL_') && authorities.includes('APP_GLOBAL:' + key.slice(11))) return true
        return authorities.includes(key)
      } else {
        return false;
      }
    }
  }

})
